import { css } from '@emotion/react';

const styles = css`
  box-sizing: content-box;
  display: flex;
  gap: var(--cds-spacing-50);
  flex-direction: column;
  padding: var(--cds-spacing-100);
`;

export default styles;
